import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AlertProvider } from './Context/AlertContext'
import { GlobalProvider } from './Context/GlobalContext'
import { RatingProvider } from './Context/RatingContext';
import './App.css';
import LandingPage from './Pages/LandingPage';
import Home from './Pages/Home';
import Category from './Pages/Category';
import Live from './Pages/Live';
import Profile from './Pages/Profile';
import Aos from 'aos';
import SingleVideo from './Pages/SingleVideo';
import Favorites from './Pages/Favorites'
import Contact from './Pages/Contact'
import Subscribe from './Pages/Subscribe';

const root = ReactDOM.createRoot(document.getElementById('root'));

Aos.init();



root.render(


  <AlertProvider>
    <BrowserRouter>
      <GlobalProvider>
        <RatingProvider>

          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/home" element={<Home />} />
            <Route path="/category" element={<Category />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/live" element={<Live />} />
            <Route path="/singlevideo" element={<SingleVideo />} />
            <Route path="/favorites" element={<Favorites />} />
            <Route path="/favorites" element={<Favorites />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/subscribe" element={<Subscribe />} />
          </Routes>

        </RatingProvider>
      </GlobalProvider>
    </BrowserRouter>
  </AlertProvider>


);
